import { isOnDev } from '#lib/utils/env/isOnDev/isOnDev.js';
import { isOnStaging } from '#lib/utils/env/isOnStaging/isOnStaging.js';

export const FeatureFlags = Object.freeze({
	PhoneContactConsent: isOnDev(),
	Printing: isOnDev(), // Please don't remove
	TestTokenDownload: isOnStaging(), // Please don't remove, here for testing purposes
	Wishlist: isOnDev(),
	loadButtonBeforeInfiniteScroll: isOnDev(),
	OpenpanelUpdates: isOnDev(),
	// The prerender route list is derived from production whatever environment
	// asks for it, so it cannot follow a RestPages entry: flip to true once the
	// website-api release carrying /pages/prerender-routes is on production, then
	// remove with the sitemap flags.
	PrerenderRoutesViaRest: false,
	// One entry per REST-migrated page whose QA ticket is not yet Ready for Prod,
	// keyed by the tracker's Page column. Ladder and removal: rest-migration/feature-flags.md
	RestPages: Object.freeze({
		'/spins': isOnDev(),
		'/privacy/[slug]': isOnDev(),
		'/privacy-mobile/[slug]': isOnDev(),
		'/news/terms': isOnDev(),
		'/news/terms-mobile': isOnDev(),
		'/shop/terms': isOnDev(),
		'/editions/terms': isOnDev(),
		'/primary/terms': isOnDev(),
		'/spins/terms': isOnDev(),
		'/nft/terms/[slug]': isOnDev(),
		'/faq (layout)': isOnDev(),
		'/faq': isOnDev(),
		'/faq/[slug]': isOnDev(),
		'/faq/[slug]/[subCategorySlug]': isOnDev(),
		'/faq/[slug]/[subCategorySlug]/[subSubCategorySlug]': isOnDev(),
		'/faq/more-from-heni': isOnDev(),
		'/faq/recent-releases': isOnDev(),
		'/news (layout)': isOnDev(),
		'/news': isOnDev(),
		'/news/data': isOnDev(),
		'/news/view/[id]': isOnDev(),
		// The /news reads that run client-side (tracker Phase C), keyed by the
		// tracker's Consumer cell since they have no route of their own.
		'NewsSearchSuggestions (news header search)': isOnDev(),
		'NewsHomePage feed paging and text search': isOnDev(),
		'/news/newsletter/[slug]': isOnDev(),
		'/news/newsletter/[slug]/share-text': isOnDev(),
		'/newsletter': isOnDev(),
		'/newsletter/[slug]': isOnDev(),
		'/newsletter/[slug]/subscription': isOnDev(),
		'/talks': isOnDev(),
		'/talks/[slug]': isOnDev(),
		'/talks/speakers': isOnDev(),
		'/talks/gallery': isOnDev(),
		'/talks/podcasts': isOnDev(),
		'/talks/podcasts/[slug]': isOnDev(),
		'/talks/podcasts/[slug]/episodes/[slug]': isOnDev(),
		'/editions': isOnDev(),
		'/editions/[slug]': isOnDev(),
		'/editions/series/[slug]': isOnDev(),
		'/editions/artwork/[slug]': isOnDev(),
		'/editions/gallery': isOnDev(),
		'/artists': isOnDev(),
		'/exhibitions/[slug]': isOnDev(),
		'/artists/[slug]': isOnDev(),
		'/shop (layout)': isOnDev(),
		'/shop': isOnDev(),
		'/shop/all': isOnDev(),
		'/shop/merch': isOnDev(),
		'/shop/merch/[slug]': isOnDev(),
		'/shop/collections': isOnDev(),
		'/shop/collections/[slug]': isOnDev(),
		'/shop/artists-and-authors': isOnDev(),
		'/shop/books': isOnDev(),
		'/shop/books/[slug]': isOnDev(),
		'/shop/books/series/[slug]': isOnDev(),
		'/shop/books/choose-your-option/[id]': isOnDev(),
		'/search': isOnDev(),
		'/': isOnDev(),
		'/nft (layout)': isOnDev(),
		'/nft': isOnDev(),
		'/nft/collections/[collectionSlug]': isOnDev(),
		'/nft/collections/[collectionSlug]/[tokenId]': isOnDev(),
		'/nft/sales-reports/[collectionSlug]': isOnDev(),
		'/nft/verify': isOnDev(),
		'/nft/verify/result': isOnDev(),
		'/nft/redeem/[slug]': isOnDev(),
		'/nft/complete-redemption/[collectionSlug]': isOnDev(),
		'/nft/my-nfts': isOnDev(),
		'/nft/order-confirmed': isOnDev(),
		'/hat': isOnDev(),
		'/hat/[id]': isOnDev(),
		'/hat/claim': isOnDev(),
		'/hat/my-hats': isOnDev(),
		'/hat/register/[eventId]': isOnDev(),
		'/hat/registration/[eventId]': isOnDev(),
		'/invoice/checkout': isOnDev(),
		'/primary (layout)': isOnDev(),
		'/primary': isOnDev(),
		'/primary/releases': isOnDev(),
		'/primary/release/[slug]': isOnDev(),
		'/primary/collection/[collectionSlug]': isOnDev(),
		'/primary/collection/[collectionSlug]/artwork/[slug]': isOnDev(),
		'/shop/checkout': isOnDev(),
		'/shop/order-confirmed': isOnDev(),
		'/editions/checkout/[dropPageSlug]': isOnDev(),
		'/editions/resume-checkout': isOnDev(),
		'/editions/order-confirmed/[dropPageSlug]': isOnDev(),
		'/primary/apply': isOnDev(),
		'/primary/apply/[dropPageSlug]': isOnDev(),
		'/primary/application-preferences/[dropPageSlug]': isOnDev(),
		'/primary/checkout/[dropPageSlug]': isOnDev(),
		'/primary/enquiry/[dropPageSlug]/thank-you': isOnDev(),
		'/primary/order-confirmed/[dropPageSlug]': isOnDev(),
		'/primary/resume-checkout': isOnDev(),
		'/vault/withdraw': isOnDev(),
		'/vault/withdraw/confirmed': isOnDev(),
		'/vault-outstanding/pay': isOnDev(),
		'/vault-outstanding/pay/confirmed': isOnDev(),
		'/aml (layout)': isOnDev(),
		'/aml/thank-you (layout)': isOnDev(),
		'/aml-upload': isOnDev(),
		'/sitemap1.xml': isOnDev(),
		'/sitemap2.xml': isOnDev(),
		'/sitemap-news.xml': isOnDev(),
		'/rss/news.xml': isOnDev(),
		// Client-side reads (tracker Phase C), keyed by the tracker's Consumer
		// cell since they have no route of their own.
		'GlobalSearch (global header search)': isOnDev(),
		'FaqSearch (FAQ header search)': isOnDev(),
		'RegisterInterest series search': isOnDev(),
		'PrimaryArtworkAutocomplete (apply preferences)': isOnDev(),
		'Shop and merch cart hydration': isOnDev(),
		'Publishing cart hydration': isOnDev(),
		'Editions cart hydration': isOnDev(),
		'NFT cart hydration': isOnDev(),
		'Primary cart and wishlist hydration': isOnDev(),
		'ResumeCheckoutPage drop page read': isOnDev(),
		'Vault drop config reads': isOnDev(),
		'NFT redemption steps': isOnDev(),
		'/invoice/order-confirmed': isOnDev(),
		'/shop/artists-and-authors/[slug]': isOnDev(),
		'News latest open drop helper': isOnDev(),
		'/api-svelte/editions/revalidate-editions': isOnDev(),
		'/api-svelte/editions/revalidate-series': isOnDev(),
		'/api-svelte/exhibition/revalidate-exhibition': isOnDev(),
		'/api-svelte/merch/revalidate-merch': isOnDev(),
		'/api-svelte/primary/revalidate-primary': isOnDev(),
		'/api-svelte/publishing/revalidate-publishing': isOnDev(),
		'/api-svelte/artists/revalidate-artists': isOnDev(),
	}),
});
